<template>
  <div id="app">
		<NavBar />
		<section id="separador"></section>
		<router-view></router-view>
    
	</div>
</template>

<script>
import NavBar from "./components/NavBar";

export default {
  name: "App",
  components: {
    NavBar
  }
};
</script>

<style>
.pace {
  -webkit-pointer-events: none;
  pointer-events: none;

  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.pace-inactive {
  display: none;
}

.pace .pace-progress {
  background: #882821;
  position: fixed;
  z-index: 2000;
  top: 62px;
  right: 100%;
  width: 100%;
  height: 4px;
}

@keyframes cssAnimation {
  to {
    width: 0;
    height: 0;
    overflow: hidden;
    color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
  }
}

@-webkit-keyframes cssAnimation {
  to {
    width: 0;
    height: 0;
    visibility: hidden;
    color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 0;
  box-shadow: -1px 0 rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0);
  border-radius: 7px;
}

.scroller {
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

.clear {
  clear: both;
}

.dark-color {
  color: black;
}

.light-color {
  color: white;
}

html, body {
  margin: 0;
  padding: 0;
  border: 0;
}

a {
  text-decoration: none;
  color: #882821;
  font-weight: bold;
}

.publicado {
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: #d4edda !important;
}

.publicado:hover {
  color: #d4edda !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.revisao {
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: #fff3cd !important;
}

.revisao:hover {
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: #fff3cd !important;
  filter: brightness(100%) !important;
}

.recusado {
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: #f8d7da !important;
}

.recusado:hover {
  color: #f8d7da !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.rascunho {
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: #a189807a !important;
}

.rascunho:hover {
  color: white !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.quadradinho {
  color: rgba(0, 0, 0, 0.7);
  font-family: "Krub", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding: 5px 15px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
  margin: 6px;
}

#hideMe {
  -moz-animation: cssAnimation 0s ease-in 7s forwards;
  /* Firefox */
  -webkit-animation: cssAnimation 0s ease-in 7s forwards;
  /* Safari and Chrome */
  -o-animation: cssAnimation 0s ease-in 7s forwards;
  /* Opera */
  animation: cssAnimation 0s ease-in 7s forwards;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.icon {
  display: none !important;
}

.ative {
  background-color: rgba(0, 0, 0, 0);
  background-position: top;
  background-repeat: no-repeat;
  width: 40px;
  height: 82px;
  float: right;
  margin-top: -22px;
}

.erro {
  z-index: 999999;
  left: 0;
  bottom: 0;
  width: 90%;
  position: fixed;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  padding: 30px 15px;
  border: 1px solid transparent;
}

.sucesso {
  z-index: 999999;
  left: 0;
  bottom: 0;
  width: 90%;
  position: fixed;
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
  padding: 30px 15px;
  border: 1px solid transparent;
}

.alerta {
  z-index: 999999;
  left: 0;
  bottom: 0;
  width: 90%;
  position: fixed;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
  padding: 30px 15px;
  border: 1px solid transparent;
}

input, textarea {
  padding: 2px 10px;
  width: 90%;
  margin: 5px auto;
  min-height: 25px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

button {
  float: right;
  border-radius: 4px;
  background-color: #882821;
  border: none;
  color: white !important;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 15px;
  transition: all 0.5s;
  cursor: pointer;
  margin: 5px;
}

button span {
  color: white !important;
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

button span:after {
  color: white !important;
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

button:hover span {
  color: white !important;
  padding-right: 10px;
}

button:hover span:after {
  color: white !important;
  opacity: 1;
  right: 0;
}

.entrada {
  background-color: rgb(255, 255, 255);
  padding: 5px 20px;
  margin: 0 auto;
  min-height: 100px;
}

.entrada h1 {
  float: left;
  font-size: 1rem;
  margin-left: 10px;
  margin-top: 5px;
  color: rgba(0, 0, 0, 0.9);
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.entrada h3 {
  float: left;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 5px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

.entrada h4 {
  float: left;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
  margin-top: -5px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.entrada form.entrar {
  padding: 15px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.07);
}

.entrada form.cadastrar {
  padding: 15px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.07);
}

.entrada form.cadastrar button {
  width: 100%;
  float: none;
  margin: 5px 0 0 0;
}

.entrada li {
  list-style: none;
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 9px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.entrada span {
  margin-top: 2px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.7);
  margin-top: -9px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

.entrada #cadastrado {
  float: right;
  width: 100px;
  height: 170px;
  margin-top: -10px;
  background-color: rgba(0, 0, 0, 0.07);
  padding: 7px;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: -10px;
  background-size: 80px;
  text-align: center;
}

.entrada #cadastrado h4 {
  width: 100%;
  text-align: center;
  font-size: 10px;
}

.entrada #cadastrado p {
  width: 100%;
  text-align: center;
  font-size: 9px;
}

.container {
  width: 95%;
  margin: 0 auto;
}

h2.titulo {
  padding: 0 !important;
  margin: 10px 0 0 10px !important;
  font-family: "Krub", sans-serif !important;
  font-weight: 700 !important;
  font-size: 1.125rem !important;
}

#procurar-perfil {
  width: inherit;
  margin: 15px 10px;
  height: 250px;
  background-size: 220%;
  background-position: left bottom;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  border-right: 2px solid rgba(0, 0, 0, 0.2);
  border-left: 2px solid rgba(0, 0, 0, 0.2);
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

#procurar-perfil img {
  display: inline-block;
  width: 20px;
  margin: 15px 0 0 15px;
}

#procurar-perfil .textinho {
  margin: 15px 0 0 15px;
}

#procurar-perfil span {
  text-align: left;
  line-height: 0.5;
  font-family: "Krub", sans-serif !important;
  font-weight: 300 !important;
  font-size: 1rem !important;
  color: white;
}

#procurar-perfil form {
  float: left;
  width: auto;
  height: 35px;
  padding: 5px;
  margin: 60px 15px 15px 15px;
  background: rgb(255, 255, 255);
  border: 1px solid;
  border-radius: 5px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
}

#procurar-perfil form input {
  width: 107px;
  float: left;
  font-family: "Krub", sans-serif;
  font-size: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  height: 20px;
  margin: 2px auto 2px 2px;
  padding: 5px;
}

#procurar-perfil form select {
  width: 73px;
  margin: 3px;
  float: left;
  font-family: "Krub", sans-serif;
  font-size: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  height: 30px;
  padding: 3px;
}

#procurar-perfil form button {
  cursor: pointer;
  padding-top: 3px;
  right: 33px;
  min-width: 30px;
  height: 30px;
  background: transparent;
  border: 0;
}

#procurar-perfil form button img {
  width: 30px;
  margin: 0;
}

#perfil {
  margin: 0;
}

input.procurar {
  float: right;
  margin: 10px;
  width: 120px;
  padding: 2px 5px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

#perfil #intro {
  min-height: 80px;
  max-height: 80px;
}

#perfil #intro #bg-intro {
  z-index: -1;
  position: absolute;
  width: 100%;
  left: 0;
  height: 80px;
  background-color: #882821;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

#perfil #intro h2 {
  width: inherit;
  color: white !important;
  margin: 0 !important;
  padding: 30px 0 5px 15px !important;
  line-height: 20px;
  font-size: 1.5rem !important;
}

#perfil #intro #missao {
  width: inherit;
  color: white;
  background-color: rgba(0, 0, 0, 0.03);
  padding: 0 0 5px 15px;
  margin: 0;
}

#perfil #intro #cincoemblemas {
  z-index: 5;
  display: flex;
  width: inherit;
  height: 55px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 15px 0 0 15px;
  -webkit-overflow-scrolling: touch;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

#perfil #intro #cincoemblemas .card {
  background-size: cover;
  border-radius: 10px;
  min-width: 45px;
  height: 45px;
  display: inline-block;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

#perfil #intro #cincoemblemas .card img {
  margin-top: 0;
  width: 40px !important;
  height: 40px !important;
  z-index: 5;
  float: left;
  padding: 5px;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 5px;
  margin-right: 5px;
}

#perfil #intro #missao span {
  font-family: "Krub", sans-serif;
  font-weight: 400;
  font-size: 0.8125rem;
}

#perfil #intro img {
  margin-top: 50px;
  width: 128px;
  height: 220px;
  float: right;
}

#perfil #cadastro {
  margin: 10px 0 0 20px;
}

#perfil p {
  float: left;
  font-family: "Krub", sans-serif;
  font-weight: 300;
  font-size: 0.75rem;
  line-height: 1;
  margin: 0;
}

#perfil #botoes {
  width: inherit;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

#perfil #botoes a {
  width: 50%;
  text-align: center;
  float: left;
  padding: 20px 0px;
  font-family: "Krub", sans-serif;
  font-weight: 700;
  font-size: 1rem;
}

#perfil #botoes a:target {
  background-color: #882821db;
  color: white;
}

#perfil #botoes a:hover {
  background-color: #882821db;
  color: white;
}

#perfil p:first-child {
  margin-right: 5px;
}

#perfil #status {
  width: inherit;
  margin: 15px 130px 15px 15px;
}

#perfil #status .card {
  margin-right: 5px;
  margin-bottom: 5px;
  width: auto;
  text-align: center;
  float: left;
  border-radius: 20px;
  padding: 10px 15px;
  background-color: #882821;
}

#perfil #status .card p {
  text-align: center;
  padding: 0;
  font-family: "Krub", sans-serif !important;
  font-weight: 600;
  font-size: 0.75rem;
  color: white;
}

#habbo-camera {
  display: flex;
  width: 100%;
  height: 155px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

#habbo-camera .card {
  background-size: cover;
  min-width: 150px;
  margin: 1px;
  height: 150px;
  display: inline-block;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  border: 0.5px solid rgba(0, 0, 0, 0.6);
}

#habbo-camera .card:first-child {
  margin-left: 10px;
}

#habbo-camera .card:last-child {
  margin-right: 10px;
}

#habbo-camera .card img {
  width: 100%;
  float: left;
  background-color: rgba(255, 255, 255, 0.7);
}

#habbo-camera .card p {
  color: white;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  font-weigth: 400;
  line-heigth: 0.2;
  word-break: normal;
}

#postagens {
  width: inherit;
  margin: 2px 0;
}

#postagens .card {
  background-color: white;
  padding: 10px 10px;
  width: inherit;
  min-height: 130px;
  border-top: 0.5px solid rgba(0, 0, 0, 0.1);
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

#postagens .card-mais {
  background-color: white;
  padding: 15px 10px;
  width: inherit;
  min-height: 20px;
  text-align: center;
  border-top: 0.5px solid rgba(0, 0, 0, 0.1);
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  font-family: "Krub", sans-serif !important;
  font-weight: 800 !important;
  font-size: 1rem !important;
  color: rgba(0, 0, 0, 0.7);
}

#postagens .card:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

#postagens .card-mais:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

#postagens .card .avatar {
  float: left;
  width: 80px;
  margin-left: -10px;
}

#postagens .card .avatar img {
  width: 100%;
}

#postagens .card .autor {
  font-family: "Open Sans", sans-serif !important;
  margin-top: 5px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-weight: 600;
  font-size: 1.125rem;
  color: rgba(52, 52, 52, 0.85);
}

#postagens .card p {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  color: black;
  line-height: 1;
  max-width: 95%;
  min-height: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 2px 15px 15px 15px;
  margin: 0 10px 10px 70px;
  padding: 10px 15px 10px 15px;
}

#postagens .card span {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400 !important;
  font-size: 0.625rem !important;
  color: rgba(0, 0, 0, 0.7);
}

#postagens .card .acoes {
  float: right;
}

#postagens .card .acoes img {}

.varios {
  display: flex;
  width: 100%;
  height: 80px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

.varios .card {
  background-size: cover;
  border-radius: 10px;
  margin: 10px 5px;
  min-width: 200px;
  height: 50px;
  padding: 10px;
  display: inline-block;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.2);
}

.varios .card:first-child {
  margin-left: 10px;
}

.varios .card:last-child {
  margin-right: 10px;
}

.varios .card img {
  float: left;
  padding: 5px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  margin-right: 10px;
}

.varios .card p {
  color: rgba(0, 0, 0, 0.7);
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  font-weigth: 400;
  line-heigth: 0.2;
  word-break: normal;
}

#separador {
  height: 60px;
}

#separador-botao {
  height: 60px;
}

.le-frank {
  background-color: #590212;
}

.le-frank-texto {
  color: #590212;
}

.le-frank-noticia {
  border-top: 5px solid #590212;
}

.habbo {
  background-color: #f5bf31;
}

.habbo-texto {
  color: #f5bf31;
}

.habbo-noticia {
  border-top: 5px solid #f5bf31;
}

.tutoriais {
  background-color: #707e7a;
}

.tutoriais-texto {
  color: #707e7a;
}

.tutoriais-noticia {
  border-top: 5px solid #707e7a;
}

.mundo {
  background-color: #038c17;
}

.mundo-texto {
  color: #038c17;
}

.mundo-noticia {
  border-top: 5px solid #038c17;
}

.comunidade {
  background-color: #855804;
}

.comunidade-texto {
  color: #855804;
}

.comunidade-noticia {
  border-top: 5px solid #855804;
}

.moda {
  background-color: #a64182;
}

.moda-texto {
  color: #a64182;
}

.moda-noticia {
  border-top: 5px solid #a64182;
}

.jogos {
  background-color: #01a1a2;
}

.jogos-texto {
  color: #01a1a2;
}

.jogos-noticia {
  border-top: 5px solid #01a1a2;
}

.espaco-card {
  min-width: 4px;
  max-width: 4px;
  display: inline-block;
}

#categoria {
  width: 100%;
  height: 40px;
  position: fixed;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.artigos {
  display: flex;
  width: 100%;
  height: 220px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

.artigos .card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 10px 5px;
  padding: 10px;
  min-width: 280px;
  max-width: 280px;
  height: 190px;
  display: inline-block;
}

.artigos .card .conteudo {
  margin: 0 auto;
  width: inherit;
  height: inherit;
  float: left;
}

.artigos .card .conteudo .resumo {
  width: inherit;
  height: 120px;
}

.artigos .card .conteudo .resumo p {
  font-size: 1rem;
  width: inherit;
  font-weight: 700;
  color: white;
  margin: 0;
  padding: 7px 7px 0 7px;
  float: left;
}

.artigos .card .conteudo .resumo span {
  font-size: 0.875rem;
  width: inherit;
  font-weight: 300;
  color: white;
  margin: 0;
  padding: 0 7px;
  float: left;
}

.artigos .card .conteudo .comentarios {
  list-style-type: none;
  padding: 3px 7px;
  font-size: 0.8175rem;
  color: white;
  font-weight: 600;
  float: left;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  margin-top: 49px;
}

.artigos .card .conteudo .autor {
  width: 64px;
  height: 87px;
  float: right;
  margin-top: -7px;
  margin-right: -10px;
}

.artigos .card .conteudo li {
  list-style-type: none;
  float: right;
  margin-top: 49px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  font-size: 0.8175rem;
  color: white;
  border-radius: 5px;
  padding: 3px 7px;
  margin-right: -5px;
}

#procurar {
  position: fixed;
  bottom: 0;
  z-index: 90;
  width: 100%;
  margin: 0;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

#procurar input {
  float: left;
  width: 70%;
  height: 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-family: "Krub", sans-serif;
  padding: 2px;
}

#procurar a {
  float: left;
  margin: 2px 5px 5px 10px;
  color: white;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

#todos-artigos {
  width: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-family: "Krub", sans-serif;
  font-weight: 600;
}

#todos-artigos .card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 10px 10px;
  padding: 10px;
  width: inherit;
  height: 190px;
}

#todos-artigos .card:first-child {
  margin-left: 10px;
}

#todos-artigos .card:last-child {
  margin-right: 10px;
}

#todos-artigos .card .conteudo {
  margin: 0 auto;
  width: inherit;
  height: inherit;
  float: left;
}

#todos-artigos .card .conteudo .resumo {
  width: inherit;
  height: 120px;
}

#todos-artigos .card .conteudo .resumo p {
  font-size: 1rem;
  width: inherit;
  font-weight: 700;
  color: white;
  margin: 0;
  padding: 7px 7px 0 7px;
  float: left;
}

#todos-artigos .card .conteudo .resumo span {
  font-size: 0.875rem;
  width: inherit;
  font-weight: 300;
  color: white;
  margin: 0;
  padding: 0 7px;
  float: left;
}

#todos-artigos .card .conteudo .comentarios {
  list-style-type: none;
  padding: 3px 7px;
  font-size: 0.8175rem;
  color: white;
  font-weight: 600;
  float: left;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  margin-top: 49px;
}

#todos-artigos .card .conteudo .autor {
  width: 64px;
  height: 87px;
  float: right;
  margin-top: -7px;
  margin-right: -10px;
}

#todos-artigos .card .conteudo li {
  list-style-type: none;
  float: right;
  margin-top: 49px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  font-size: 0.8175rem;
  color: white;
  border-radius: 5px;
  padding: 3px 7px;
  margin-right: -5px;
}

.comentarios {
  width: inherit;
}

.comentarios .comentario:first-child {
  margin-top: 15px;
}

.comentarios .comentario {
  width: inherit;
  padding: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.01);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-top: 10px;
}

.comentarios .comentario img.autor {
  float: right;
  margin: -10px -13px;
}

.comentarios .comentario h5 {
  width: inherit;
  margin: 0 5px 5px 5px;
  font-family: "Krub", sans-serif;
  font-weight: 600;
  font-size: 0.9375rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.comentarios .comentario p {
  width: inherit;
  margin: 0 5px 5px 5px;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 0.8125rem;
}

.comentarios .comentario img.relogio {
  width: 13px;
}

.comentarios .comentario span {
  width: inherit;
  font-family: "Open Sans", sans-serif;
  font-weight: 200;
  font-size: 0.75rem;
  margin: 0 5px;
}

.comentarios #comentar {
  width: inherit;
  padding: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.comentarios #comentar span {
  margin: 0;
  color: rgba(0, 0, 0, 0.8) !important;
  font-size: 0.875rem;
  font-weight: 400;
}

#anuncio-cima {
  width: inherit;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: "Krub", sans-serif;
  line-height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 10px 15px;
}

#anuncio-rodape {
  width: inherit;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: "Krub", sans-serif;
  line-height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 10px 15px;
}
</style>
